import { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axiosInstance from "../../helpers/axios";
import { UserType } from "../../data";
import { useCurrentUser } from '../../hooks/useCurrentUser';

export default function AddMembers({activeTab}) {

  const decode = useCurrentUser();
  const user = null;
  const [openRoles, setOpenRoles] = useState(false);
  const [selectedRole, setSelectedRole] = useState("Select Role");
  // const [newName, setNewName] = useState(null);
  // const [newEmail, setNewEmail] = useState(null);
  // const [newMobile, setNewPhone] = useState(null);
  const [newName, setNewName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newMobile, setNewPhone] = useState("");
  const [usersList, setUserList] = useState([])
  // const [new,setNewEmail]=useState(null)

  //get institute

  

  const [instituteList, setInstituteList] = useState(null);
  const [selectedInstituteId, setSelectedInstituteId] = useState(null);

  const [instituteBranches, setInstituteBranches] = useState([]);
  const [selectedInstituteBranchId, setSelectedInstituteBranchId] =
    useState("");


  const [selectedClientAllBranches, setSelectedClientAllBranches] = useState([]);
  const [selectedClientBranchId, setSelectedClientBranchId] = useState("");
  const [rmId, setRMId] = useState("")
  const [selectedPartner, setSelectedPartner] = useState("");
  // const handleClientChange = async (e) => {
  //   const clientId = e.target.value;
  //   setSelectedClientId(clientId);
  //   

  //   if (clientId) {
  //     const branches = await getSelectedClientBranchesApi(clientId);
  //     
  //     setSelectedClientAllBranches(branches || []);
  //     // setBranches(branches || []);
  //   }
  // };



 

 const handleClientBranchChange = async (e) => {
  const clientBranchId = e.target.value;
  setSelectedClientBranchId(clientBranchId)
};

const handleSelectPartner = async (e) => {
  const partnerId = e.target.value;
  setSelectedPartner(partnerId)
};

  async function getSelectedClientBranchesApi(clientId) {
    try {
      const response = await axiosInstance.get(
        "/client-branches/info/clientId",
        {
          params: { clientId },
          headers: {
          },
        }
      );

      return response.data.data.branches || [];
    } catch (error) {
      console.error(
        "Error fetching branches:",
        error.response ? error.response.data : error.message
      );
      return [];
    }
  }

  const fetchBranches = async () => {
    if (!decode?.clientId) return;

    try {
      const branches = await getSelectedClientBranchesApi(decode?.clientId);
      setSelectedClientAllBranches(branches || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };
  const [partners,setPartners] = useState([])
  useEffect(() => {
    fetchBranches();
    axiosInstance.get(`/channel-partners/get-partners`)
    .then((res)=>{
      setPartners(res?.data?.data)
    }).catch((err) => err)
  }, [decode?.clientId]); 

  useEffect(() => {
    if(activeTab==="2"){
      getAllUsers()
    }
  }, [activeTab])
  






  const handleBranchChange = (e) => {
    const branchId = e.target.value;
    setSelectedInstituteBranchId(branchId);
  };

  const getInstituteBranchesListApi = async (instituteId) => {
    axiosInstance
      .get(`/institute-branches/info/instituteId?instituteId=${instituteId}`, {
        headers: {
        },
      })
      .then((res) => {
        const branchesList = res?.data?.data?.branches;
        setInstituteBranches(branchesList);
      })
      .catch(function (error) {
      });
  };

  const getInstituteInfo = (text) => {
    const instituteInfoUrl = `/institute/info/name?name=${text}`;
    if (text.length >= 4) {
      axiosInstance
        .get(instituteInfoUrl, {
          headers: {
          },
        })
        .then((res) => {
          if (res.data.data == []) {
            setInstituteList(null);
          } else setInstituteList(res.data.data);
        });
    } else {
      setInstituteList(null);
    }
  };

  const handleSearchInstituteDetails = (data) => {
    // setCurrentInstituteId(data.id)
    document.getElementById("instituteNameField").value = data.brandName;
    setInstituteList(null);
    setSelectedInstituteId(data.id);
    getInstituteBranchesListApi(data.id);
  };

  const randomPassword = () => {
    let randArr = [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];

    let randPassword = "";
    for (let i = 0; i < 8; i++) {
      randPassword += randArr[Math.floor(Math.random() * randArr.length)];
    }
    return randPassword;
  };

 const validateEmail = (email) => {
    if (typeof email !== 'string') return false;
    const emailToValidate = email.trim();

    // Use the corrected and robust regex
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    return regex.test(emailToValidate);
  };

  const [submitButton, setSubmitButton] = useState(false);
  const handleAddNewRole = () => {
   if (decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && !selectedClientBranchId) {
      alert("Please select the branch");
      setSubmitButton(false);
      return; 
    }
    if (!newName || !newEmail || !newMobile) {
      window.alert("All fields (Name, Email, Phone) are required.");
      setSubmitButton(false);
      return;
    }
    if (decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && !rmId) {
      alert("Please select the Reporting Manager");
      setSubmitButton(false);
      return; 
    }
   
    if (selectedRole === "institute_user" && !selectedInstituteId) {
      window.alert("Please select an institute.");
      setSubmitButton(false);
      return;
    }
    setSubmitButton(true);
    if (validateEmail(newEmail)) {
      const urlAddNewRole = "/admin/create-user";
      const urlAddNewInstituteUser = "/admin/create-institute-user";
      // const body = {
      //   name: newName,
      //   mobile: newMobile,
      //   emailId: newEmail,
      //   password: randomPassword(),
      //   role: selectedRole,
      //   instituteId: selectedInstituteId
      //     ? selectedInstituteId
      //     : decode?.role === "institute_admin"
      //     ? decode?.instituteId
      //     : "",
      //   // clientId:"",
      //   // clientId: decode?.clientId,
      //   clientId:selectedClientId,
      //   clientBranchId: "",
      //   instituteBranchId: selectedInstituteBranchId,
      // };

      if (decode?.role === "institute_admin") {
        const body = {
          name: newName,
          mobile: newMobile,
          emailId: newEmail,
          password: randomPassword(),
          role: selectedRole,
          instituteId: selectedInstituteId
            ? selectedInstituteId
            : decode?.role === "institute_admin"
            ? decode?.instituteId
            : "",
          // clientId:"",
          clientId: decode?.clientId,
          // clientId:selectedClientId,
          clientBranchId: "",
          instituteBranchId: selectedInstituteBranchId,
        };
        axiosInstance
          .post(urlAddNewInstituteUser, body, {
            headers: {
            },
          })
          .then((res) => {
            
            setSubmitButton(false);
            setSelectedClientBranchId("")
            setSelectedClientAllBranches([])
            setSelectedInstituteId("");  
            setSelectedInstituteBranchId("");
            setInstituteList("")
            setNewName("")
            setNewEmail("")
            setNewPhone("")
            window.alert(
              "Added Successfully \n Email is sent to the user for login instructions."
            );
            fetchBranches()
          })
          .catch((err) => {
            window.alert(err?.response?.data?.message);
            setSubmitButton(false);
          });
      } else {

        const body = {
          name: newName,
          mobile: newMobile,
          emailId: newEmail,
          password: randomPassword(),
          role: selectedRole,
          instituteId:(selectedRole === "channel_user" ? "Channel":(
            selectedInstituteId
            ? selectedInstituteId
            : decode?.role === "institute_admin"
            ? decode?.instituteId
            : ""
          )) ,
          // clientId:"",
          clientId: decode?.clientId,
          // clientId:selectedClientId,
          clientBranchId: selectedClientBranchId,
          instituteBranchId:selectedInstituteBranchId ,
          channel:selectedRole === "channel_user"?8:null,
          channelPartnerId:selectedRole === "channel_user"?selectedPartner:null,
          rmId
        };

        axiosInstance
          .post(urlAddNewRole, body, {
            headers: {
            },
          })
          .then((res) => {
            
            setSubmitButton(false);
            setSelectedClientBranchId("")
            setSelectedClientAllBranches([])
            setSelectedInstituteId("");  
            setSelectedInstituteBranchId("");
            setInstituteList("")
            setNewName("")
            setNewEmail("")
            setNewPhone("")
            setRMId("")
            alert( "Added Successfully\nEmail is sent to the user for login instructions.");
            fetchBranches() 
          })
          .catch((err) => {
            window.alert(`${err?.response?.data?.message}`);
            setSubmitButton(false);
          });
      }
    } else {
      window.alert("Enter valid email!");
      setSubmitButton(false);
    }
  };

  const getAllUsers =async () => {
    try {
      const res = await axiosInstance("/admin/users", {
        headers:{
        }
      })
      // 
      setUserList(res?.data?.data)
    } catch (error) {
      console.error('Failed to get users')
    }
  }

  return (
    <div style={{ display: "block", margin: "3%", height: "100%" }}>
      <Dropdown isOpen={openRoles} toggle={() => setOpenRoles(!openRoles)}>
        <DropdownToggle
          caret
          style={{ backgroundColor: "#d32028", border: "none" }}
        >
          {selectedRole === "cra"
            ? "CRA"
            : selectedRole === "institute_admin"
            ? "Inst. Admin"
            : selectedRole === "institute_user"
            ? "Inst. User"
            : selectedRole.toUpperCase()}
        </DropdownToggle>
        {selectedRole !== "Select Role" ? (
          " "
        ) : (
          <small>
            {" "}
            <i>Select a role to begin with</i>
          </small>
        )}
        <DropdownMenu>
          {decode?.role !== "institute_admin" && decode?.clientId!=='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
          decode?.role !== "institute_user" ? (
            <>
              <DropdownItem onClick={(e) => setSelectedRole(UserType.Admin)}>
                Feemonk Admin
              </DropdownItem>
              <DropdownItem onClick={(e) => setSelectedRole(UserType.Finance)}>
                Finance
              </DropdownItem>
              <DropdownItem
                onClick={(e) => setSelectedRole(UserType.LoanProcessor)}
              >
                CRA
              </DropdownItem>
              <DropdownItem
                onClick={(e) => setSelectedRole(UserType.InstituteAdmin)}
              >
                Institute Admin
              </DropdownItem>
              <DropdownItem
                onClick={(e) => setSelectedRole(UserType.InstituteUser)}
              >
                Institute User
              </DropdownItem>
              <DropdownItem
                onClick={(e) => setSelectedRole(UserType.Collection)}
              >
                Collections
              </DropdownItem>
              <DropdownItem
                onClick={(e) => setSelectedRole(UserType.ChannelUser)}
              >
                Channel User
              </DropdownItem>
            </>
          ) : decode?.role === "institute_admin" ? (
            <>
              <DropdownItem
                onClick={(e) => setSelectedRole(UserType.InstituteUser)}
              >
                Institute User
              </DropdownItem>
            </>
          ) : (
            ""
          )}
          {
            decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
            <>
              <DropdownItem onClick={(e) => setSelectedRole(UserType.Admin)}>
                Admin
              </DropdownItem>
              <DropdownItem onClick={(e) => setSelectedRole(UserType.Executive)}>
                Executive
              </DropdownItem>
            </>
          }
        </DropdownMenu>
      </Dropdown>

      {selectedRole !== "institute_user" && selectedRole !== "institute_admin" && selectedRole !== "Select Role" ? (
        <div
          style={{
            display: "block",
            padding: "1em",
            justifyContent: "space-between",
            backgroundColor: "#F8F8F8",
            boxShadow: "0px 0px 6px 0px rgb(0,0,0,0.3)",
            marginTop: "1em",
            borderRadius: "10px",
          }}
        >
          <h3 style={{ textAlign: "center" }}>
            Add{" "}
            <strong style={{ textDecoration: "underline" }}>
              {" "}
              {selectedRole === "cra"
                ? "CRA"
                : selectedRole === "institute_admin"
                ? "Inst. Admin"
                : selectedRole === "institute_user"
                ? "Inst. User"
                : selectedRole === "channel_user"
                ? "Channel"
                : selectedRole.toUpperCase()}
            </strong>{" "}
            User
          </h3>

           {/* client fetch begin */}
           {/* <div>
            <FormGroup
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                margin: "0.5em",
              }}
            >
              <Label
                htmlFor="client"
                style={{ marginLeft: "1rem" }}
              >
                <span
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Client
                </span>
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="select"
                name="client"
                id="client"
                value={selectedClientId}
                onChange={handleClientChange}
                style={{ width: "15em", marginLeft: "1.5rem" }}
              >
                <option value="" disabled>
                  Select client
                </option>
                {clientList.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div> */}

          {/* end */}

          {/* selected client branches begin */}
          <div>
            <FormGroup
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                margin: "0.5em",
              }}
            >
              <Label
                htmlFor="client branches"
                // style={{ marginLeft: "3rem" }}
              >
                <span
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Client Branch
                </span>
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="select"
                name="client branches"
                id="client branches"
                value={selectedClientBranchId}
                onChange={handleClientBranchChange}
                style={{ width: "15em", marginLeft: "-1.8rem" }}
              >
                <option value="" disabled>
                  Select client Branch
                </option>
                {selectedClientAllBranches.map((clientBranch) => (
                  <option key={clientBranch.branchId} value={clientBranch.branchId}>
                    {clientBranch.branchName}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div>
          {selectedRole === "channel_user" ? (
          <div>
          <FormGroup
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <Label
              htmlFor="client branches"
              // style={{ marginLeft: "3rem" }}
            >
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
              Channel Partner
              </span>
              <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="select"
              name="client branches"
              id="client branches"
              value={selectedPartner}
              onChange={handleSelectPartner}
              style={{ width: "15em", marginLeft: "-2.7rem" }}
            >
              <option value="" disabled>
                Select Channel Partner
              </option>
              {partners.map((partner) => (
                <option key={partner.partnerId} value={partner.partnerId}>
                  {partner.name}
                </option>
              ))}
            </Input>
          </FormGroup>
        </div>
          ):""}
        

          {/* end */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>Name</p>
            <input
              style={{
                borderRadius: "10px",
                border: "1px solid #DbDbDb",
                paddingLeft: "10px",
              }}
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>Email</p>
            <input
              style={{
                borderRadius: "10px",
                border: "1px solid #DbDbDb",
                paddingLeft: "10px",
              }}
              type="text"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>Phone</p>
            <input
              min="0"
              style={{
                borderRadius: "10px",
                border: "1px solid #DbDbDb",
                paddingLeft: "10px",
              }}
              type="number"
              value={newMobile}
              onChange={(e) => setNewPhone(e.target.value)}
            />
          </div>
          {decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&
             <div>
            <FormGroup
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                margin: "0.5em",
              }}
            >
              <Label
                htmlFor="Reporting Manager"
                // style={{ marginLeft: "3rem" }}
              >
                <span
                  style={{
                    fontFamily: "Outfit",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Reporting Manager
                </span>
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="select"
                name="client branches"
                id="client branches"
                value={rmId}
                onChange={(e) => setRMId(e.target.value)}
                style={{ width: "16em", }}
              >
                <option value="" disabled>
                  Select Reporting Manager
                </option>
                {usersList?.filter(eachUser => eachUser?.role==="admin")?.map((user) => (
                  <option key={user.userId} value={user.userId}>
                    {user.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div>
          }
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2em",
            }}
          >
            <Button
              disabled={submitButton}
              onClick={() => handleAddNewRole()}
              style={{ backgroundColor: "#D32028", border: "none" }}
            >
              Submit
            </Button>
          </div>
        </div>
      ) : selectedRole !== "Select Role" &&
        selectedRole === "institute_user" || selectedRole === "institute_admin" ? (
        <div
          style={{
            display: "block",
            padding: "1em",
            justifyContent: "space-between",
            backgroundColor: "#F8F8F8",
            boxShadow: "0px 0px 6px 0px rgb(0,0,0,0.3)",
            marginTop: "1em",
            borderRadius: "10px",
          }}
        >
          <h3 style={{ textAlign: "center" }}>
            Add{" "}
            <strong style={{ textDecoration: "underline" }}>
              {" "}
              {selectedRole === "cra"
                ? "CRA"
                : selectedRole === "institute_admin"
                ? "Inst. Admin"
                : selectedRole === "institute_user"
                ? "Inst. User"
                : selectedRole.toUpperCase()}
            </strong>{" "}
            User
          </h3>

          {/* client fetch begin */}
          {/* <div>
            <FormGroup
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                margin: "0.5em",
              }}
            >
              <Label
                htmlFor="client"
                style={{ marginLeft: "1rem" }}
              >
                <span
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Client
                </span>
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="select"
                name="client"
                id="client"
                value={selectedClientId}
                onChange={handleClientChange}
                style={{ width: "15em", marginLeft: "1.5rem" }}
              >
                <option value="" disabled>
                  Select client
                </option>
                {clientList.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div> */}

          {/* end */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>
              Institute
            </p>
            <div style={{ display: "block" }}>
              <input
                id="instituteNameField"
                style={{
                  borderRadius: "10px",
                  border: "1px solid #DbDbDb",
                  padding: "4px",
                }}
                type="text"
                // value = {selectedInstitute}
                onChange={(e) => getInstituteInfo(e.target.value)}
              />
              <div
                style={{
                  marginTop: "0.2em",
                  position: "absolute",
                  zIndex: "999",
                  backgroundColor: "#fff",
                  width: "14em",
                  borderRadius: "10px",
                  border: "1px solid aliceBlue",
                }}
              >
                {instituteList
                  ? instituteList.map((item) => {
                      return (
                        <div
                          onClick={() => handleSearchInstituteDetails(item)}
                          className="instituteName"
                          style={{
                            cursor: "pointer",
                            border: "1px solid #DbDbDB",
                            borderRadius: "0.5em",
                          }}
                        >
                          <p
                            style={{
                              fontWeight: "600",
                              paddingTop: "0.5em",
                              paddingLeft: "0.5em",
                            }}
                          >
                            {item.brandName}
                          </p>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>

          <div>
            <FormGroup
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                margin: "0.5em",
              }}
            >
              <Label
                htmlFor="instituteBranch"
                style={{ marginLeft: "1rem", marginRight: "-1rem" }}
              >
                <span
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Institute Branch
                </span>
                <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                type="select"
                name="instituteBranch"
                id="instituteBranch"
                value={selectedInstituteBranchId}
                onChange={handleBranchChange}
                style={{ width: "15em", marginLeft: "-2.5rem" }}
              >
                <option value="" disabled>
                  Select Institute Branch
                </option>
                {instituteBranches.map((branch) => (
                  <option key={branch.branchId} value={branch.branchId}>
                    {branch.branchName}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </div>

          <div
            style={{
              border: "1px dashed #000",
              width: "60%",
              marginLeft: "20%",
              boxShadow: "0px 0px 6px 0px rgb(0,0,0,0.4)",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
              marginTop: "2em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>Name</p>
            <input
              style={{
                borderRadius: "10px",
                border: "1px solid #DbDbDb",
                paddingLeft: "10px",
              }}
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>Email</p>
            <input
              style={{
                borderRadius: "10px",
                border: "1px solid #DbDbDb",
                paddingLeft: "10px",
              }}
              type="text"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "0.5em",
            }}
          >
            <p style={{ fontWeight: "bold", fontFamily: "Outfit" }}>Phone</p>
            <input
              min="0"
              style={{
                borderRadius: "10px",
                border: "1px solid #DbDbDb",
                paddingLeft: "10px",
              }}
              type="number"
              value={newMobile}
              onChange={(e) => setNewPhone(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2em",
            }}
          >
            <Button
              disabled={submitButton}
              onClick={() => handleAddNewRole()}
              style={{ backgroundColor: "#D32028", border: "none" }}
            >
              Submit
            </Button>
          </div>
        </div>
      ) : (
        " "
      )}
    </div>
  );
}
